import React, { CSSProperties } from 'react';
import { Typography } from '@material-ui/core';

import { activeStyle, normalStyle } from 'retired/LinkTab';

export const Tab = ({
  isActive,
  text,
  onClick,
  style = {},
}: {
  isActive: boolean;
  text: string;
  onClick: () => void;
  style?: CSSProperties;
}) => (
  <Typography style={{ ...(isActive ? activeStyle : normalStyle), ...style }} onClick={onClick}>
    {text}
  </Typography>
);
